import ContentsTypes from "@shared/enums/contentsTypes";
import SkillsTabsPreview from "@project/components/SkillsTabs/SkillsTabPanelPreview";
import contentsCustomTypesEnum from "@project/enums/contentsCustomTypes.enum";
export const SkillBox = {
    label: "Bloc de compétence",
    key: "items",
    type: contentsCustomTypesEnum.SKILL_BOX,
    children: [
        {
            label: "Image",
            key: "image",
            type: ContentsTypes.IMAGE,
            value: "",
        },
        {
            label: "Titre",
            key: "title",
            type: ContentsTypes.INPUT,
            value: "",
        },
    ],
};
export const SkillsTabPanelComponent = {
    label: "Description de compétences",
    type: contentsCustomTypesEnum.SKILLS_TAB_PANEL,
    Preview: SkillsTabsPreview,
    icon: "microchip",
    editionModal: true,
    editionModalPosition: "top",
    children: [
        {
            key: "title",
            label: "Titre",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            key: "text",
            label: "text",
            type: ContentsTypes.TEXT,
            value: "",
        },
        {
            key: "image",
            label: "image",
            type: ContentsTypes.IMAGE,
            value: "",
        },
        {
            key: "dynamicList",
            type: ContentsTypes.DYNAMIC_LIST,
            value: "",
            children: [
                {
                    key: "contentType",
                    children: [SkillBox],
                    value: contentsCustomTypesEnum.SKILL_BOX,
                },
            ],
        },
    ],
};
